// extracted by mini-css-extract-plugin
export default {"cancelledPaymentInfo":"CancelledView_cancelledPaymentInfo"};